import React from 'react'
import styled, { withTheme } from 'styled-components'
import { Value } from 'libreact/lib/Value'
import Modal from 'react-modal'
import Button from '../../Button'
import Buttons from './Buttons'

const modalStyle = (theme) => ({
  overlay: {
    zIndex: 11,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: theme.borderRadius.rounded,
    boxShadow: theme.boxShadow.grey,
    padding: '40px',
  },
})

const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
`

Modal.setAppElement('#root')

export default withTheme(({ theme, form }) => (
  <Value init={false}>
    {({ value, set }) => (
      <>
        <Button type='neutral' small onClick={() => set(true)}>
          Clear
        </Button>
        <Modal
          isOpen={value}
          style={modalStyle(theme)}
        >
          <Title>
            Are you sure you want to start over?
          </Title>
          <Buttons set={set} form={form} />
        </Modal>
      </>
    )}
  </Value>
))
